export default __webpack_public_path__ + "graphics/android--white.48b70036.svg";